import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import BaseConfirmationDialog from './BaseConfirmationDialog';
import {go} from "../../utils/navigationUtility";
import {withRouter} from "react-router-dom";
import {getRegisteredAt, getUserPlan, getUserProperties, isSchoolUser, isStudent, isTeacher, setUserProperties} from "../../utils/userUtility";
import {action, computed, observable} from "mobx";
import moment from "moment";
import {SubscriptionPlans} from "../../constants/enums";

const SHOW_FREEMIUM_DIALOG_CUTOFF_DATE = 'Tue Dec 07 2021 00:00:00 GMT+0200 (Israel Standard Time)';

@injectIntl
@withRouter
@inject('userStore', 'manageStore')
@observer
class FreemiumToTrialDialog extends Component {
    @observable forceClose = false;

    goToPricing = () => {
        this.close();
        go('/payment');
    }

    @action close = () => {
        setUserProperties({freemium: true});
        this.forceClose = true;
    }

    @computed get showDialog() {
        return this.props.userStore.isAuthenticated && // we are authenticated
            !this.props.location.pathname.match(/signin|signup/) &&
            !isSchoolUser() &&  // not a school user
            isTeacher() &&  // must be a teacher
            moment(getRegisteredAt()).diff(moment(SHOW_FREEMIUM_DIALOG_CUTOFF_DATE), 'days') < 0 &&
            !getUserProperties().freemium  && // we didn't see this before
            !this.forceClose && // the user didn't close
            getUserPlan() === SubscriptionPlans.Trial; // user is currently on a free account
    }


    render() {
        return <BaseConfirmationDialog
            withClose={false}
            onSubmit={this.goToPricing}
            onDismiss={this.close}
            open={this.showDialog}
            buttonText={'subscribeNow'}
            cancelButtonText={'continueWithTrial'}
            withConfirm={!isStudent()}
            text={{
                question: 'payment.freemiumToTrial.title',
                messageElement: <div className={"freemium-dialog-message"}>
                    <p><FormattedMessage id={'payment.freemiumToTrial.message1'}/></p>
                    <p><FormattedMessage id={'payment.freemiumToTrial.message2'} values={{today: moment().format('dddd[, ] DD MMMM YYYY')}}/></p>
                    <p><FormattedMessage id={'payment.freemiumToTrial.message3'}/></p>
                </div>
            }}
            isCancel={true}
        />
    }
}

export default FreemiumToTrialDialog;
